import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { checkLogin, toIndex, needLogin } from '@/assets/js/pub';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'index',
            component: resolve => require(['../views'], resolve),
            meta: { name: '首页' }
        },
        {
            path: '/bmsLogin',
            name: 'bmsLogin',
            component: resolve => require(['../views/bmsLogin.vue'], resolve),
        },
        {
            path: '/e6Login',
            name: 'e6Login',
            component: resolve => require(['../views/e6Login.vue'], resolve),
        },
        {
            path: '/noticeInfo',
            name: 'noticeInfo',
            component: resolve => require(['../views/noticeInfo.vue'], resolve),
        },
        {
            path: '/platformIntro',
            name: 'platformIntro',
            component: resolve => require(['../components/platformIntroduction.vue'], resolve),
            children: [
                {
                    path: 'index',
                    name: 'platformIntroIndex',
                    component: resolve => require(['../components/platformIntroduction.md'], resolve),
                }
            ],
        },
        {
            path: '/globalSearch',
            name: 'globalSearch',
            component: resolve => require(['../views/globalSearch.vue'], resolve),
        },
        {
            path: '/helpCenter',
            name: 'helpCenter',
            component: resolve => require(['../views/entry'], resolve),
            redirect: '/helpCenter/accessGuide/noviceGuideNewManStep1',
            children: [
                {
                    path: 'accessGuide/noviceGuideNewManStep1',
                    name: 'helpCenter.accessGuide.noviceGuideNewManStep1',
                    component: resolve => require(['../views/helpCenter/accessGuide/noviceGuide.md'], resolve)
                },
                {
                    path: 'accessGuide/noviceGuideNewManStep2',
                    name: 'helpCenter.accessGuide.noviceGuideNewManStep2',
                    component: resolve => require(['../views/helpCenter/accessGuide/noviceGuide.md'], resolve)
                },
                {
                    path: 'accessGuide/noviceGuideNewManStep3',
                    name: 'helpCenter.accessGuide.noviceGuideNewManStep3',
                    component: resolve => require(['../views/helpCenter/accessGuide/noviceGuide.md'], resolve),
                    meta: { name: '数据服务申请流程' }
                },
                {
                    path: 'accessGuide/noviceGuideNewManStep4',
                    name: 'helpCenter.accessGuide.noviceGuideNewManStep4',
                    component: resolve => require(['../views/helpCenter/accessGuide/noviceGuide.md'], resolve)
                },
                {
                    path: 'developDoc/sign',
                    name: 'helpCenter.developDoc.sign',
                    component: resolve => require(['../views/helpCenter/developDoc/sign.md'], resolve),
                    meta: { name: '签名说明' }
                },
                {
                    path: 'developDoc/httpPushStep1',
                    name: 'helpCenter.developDoc.httpPushStep1',
                    component: resolve => require(['../views/helpCenter/developDoc/httpPush.md'], resolve)
                },
                {
                    path: 'developDoc/httpPushStep2',
                    name: 'helpCenter.developDoc.httpPushStep2',
                    component: resolve => require(['../views/helpCenter/developDoc/httpPush.md'], resolve)
                },
                {
                    path: 'developDoc/httpServerStep1',
                    name: 'helpCenter.developDoc.httpServerStep1',
                    component: resolve => require(['../views/helpCenter/developDoc/httpServer.md'], resolve),
                    meta: { name: 'HTTP推送服务开发' }
                },
                {
                    path: 'developDoc/doc1',
                    name: 'helpCenter.developDoc.doc1',
                    component: resolve => require(['../views/helpCenter/developDoc/doc1.md'], resolve),
                    meta: { name: '「物联网技术」MQTT 、HTTP和 KAFKA 对比' }
                },
                {
                    path: 'developDoc/httpServerStep2',
                    name: 'helpCenter.developDoc.httpServerStep2',
                    component: resolve => require(['../views/helpCenter/developDoc/httpServer.md'], resolve),
                    meta: { name: 'HTTP推送服务开发' }
                },
                // {
                //     path: 'developDoc/httpServerStep3',
                //     name: 'helpCenter.developDoc.httpServerStep3',
                //     component: resolve => require(['../views/helpCenter/developDoc/httpServer.md'], resolve)
                // },
                // {
                //     path: 'developDoc/httpServerStep4',
                //     name: 'helpCenter.developDoc.httpServerStep4',
                //     component: resolve => require(['../views/helpCenter/developDoc/httpServer.md'], resolve)
                // },
                {
                    path: 'developDoc/mqttPushStep1',
                    name: 'helpCenter.developDoc.mqttPushStep1',
                    component: resolve => require(['../views/helpCenter/developDoc/mqttPush.md'], resolve),
                    meta: { name: 'MQTT推送服务开发' }
                },
                {
                    path: 'developDoc/mqttPushStep2',
                    name: 'helpCenter.developDoc.mqttPushStep2',
                    component: resolve => require(['../views/helpCenter/developDoc/mqttPush.md'], resolve),
                    meta: { name: 'MQTT推送服务开发' }
                },
                {
                    path: 'developDoc/kafkaPushStep1',
                    name: 'helpCenter.developDoc.kafkaPushStep1',
                    component: resolve => require(['../views/helpCenter/developDoc/kafkaPush.md'], resolve),
                    meta: { name: 'KAFKA推送服务开发' }
                },
                {
                    path: 'developDoc/kafkaPushStep2',
                    name: 'helpCenter.developDoc.kafkaPushStep2',
                    component: resolve => require(['../views/helpCenter/developDoc/kafkaPush.md'], resolve),
                    meta: { name: 'KAFKA推送服务开发' }
                },
                // {
                //     path: 'developDoc/mqttServerStep1',
                //     name: 'helpCenter.developDoc.mqttServerStep1',
                //     component: resolve => require(['../views/helpCenter/developDoc/mqttServer.md'], resolve)
                // },
                // {
                //     path: 'developDoc/mqttServerStep2',
                //     name: 'helpCenter.developDoc.mqttServerStep2',
                //     component: resolve => require(['../views/helpCenter/developDoc/mqttServer.md'], resolve)
                // },
                // {
                //     path: 'developDoc/mqttServerStep21',
                //     name: 'helpCenter.developDoc.mqttServerStep21',
                //     component: resolve => require(['../views/helpCenter/developDoc/mqttServer.md'], resolve)
                // },
                // {
                //     path: 'developDoc/mqttServerStep22',
                //     name: 'helpCenter.developDoc.mqttServerStep22',
                //     component: resolve => require(['../views/helpCenter/developDoc/mqttServer.md'], resolve)
                // },
                {
                    path: 'developDoc/mqttServerStep23',
                    name: 'helpCenter.developDoc.mqttServerStep23',
                    component: resolve => require(['../views/helpCenter/developDoc/mqttServer.md'], resolve)
                },
                {
                    path: 'developDoc/restApi',
                    name: 'helpCenter.developDoc.restApi',
                    component: resolve => require(['../views/helpCenter/developDoc/restApi.md'], resolve),
                    meta: { name: 'restApi服务' }
                },
                {
                    path: 'developDoc/readApi',
                    name: 'helpCenter.developDoc.readApi',
                    component: resolve => require(['../views/helpCenter/developDoc/readApi.md'], resolve),
                    meta: { name: '如何解读API详情' }
                },
                {
                    path: 'sdk/download',
                    name: 'helpCenter.sdk.download',
                    component: resolve => require(['../views/helpCenter/sdk/download.md'], resolve),
                    meta: { name: 'SDK下载' }
                },
                {
                    path: 'issues',
                    name: 'helpCenter.issues',
                    component: resolve => require(['../views/helpCenter/issues.md'], resolve),
                    meta: { name: '常见问题' }
                },
                {
                    path: 'error/:code',
                    name: 'error',
                    component: resolve => require(['../views/error'], resolve),
                    meta: { name: 'error' }
                }
            ],
        },
        {
            path: '/productCenter',
            name: 'productCenter',
            component: resolve => require(['../views/entry'], resolve),
            redirect: '/productCenter/restApi',
            children: [
                {
                    path: 'restApi',
                    name: 'productCenter.restApi',
                    component: resolve => require(['../views/productCenter/restApi'], resolve),
                    meta: { name: 'API列表' }
                },
                {
                    path: 'restApi/categoryDetail',
                    name: 'productCenter.restApi.categoryDetail',
                    component: resolve => require(['../views/productCenter/restApi/categoryDetail'], resolve),
                },
                {
                    path: 'restApi/detail',
                    name: 'productCenter.restApi.detail',
                    component: resolve => require(['../views/productCenter/restApi/detail'], resolve),
                },
                {
                    path: 'restApi/apply',
                    name: 'productCenter.restApi.apply',
                    component: resolve => require(['../views/productCenter/restApi/apply'], resolve),
                    meta: { name: 'API详情' }
                },
                {
                    path: 'apply',
                    name: 'productCenter.apply',
                    component: resolve => require(['../views/productCenter/apply.vue'], resolve),
                    meta: { name: '确认申请' }
                },
                {
                    path: 'success',
                    name: 'productCenter.success',
                    component: resolve => require(['../views/productCenter/success.vue'], resolve),
                    meta: { name: '申请成功' }
                },
                {
                    path: 'pushApi',
                    name: 'productCenter.pushApi',
                    component: resolve => require(['../views/productCenter/pushApi'], resolve),
                    meta: { name: '推送列表' }
                },
                {
                    path: 'pushApi/detail',
                    name: 'productCenter.pushApi.detail',
                    component: resolve => require(['../views/productCenter/pushApi/detail'], resolve),
                    meta: { name: '推送详情' }
                },
                {
                    path: 'pushApi/apply',
                    name: 'productCenter.pushApi.apply',
                    component: resolve => require(['../views/productCenter/pushApi/apply'], resolve),
                }
            ]
        },
        {
            path: '/console',
            name: 'console',
            component: resolve => require(['../views/entry'], resolve),
            redirect: '/console/appMan/restApiMan',
            children: [
                {
                    path: 'applyedApi',
                    name: 'console.applyedApi',
                    component: resolve => require(['../views/console/applyedApi'], resolve),
                },
                {
                    path: 'appMan/restApiMan',
                    name: 'console.appMan.restApiMan',
                    component: resolve => require(['../views/console/appMan/restApiMan'], resolve),
                    meta: { name: '我的API' }
                },
                {
                    path: 'appMan/mqttMan',
                    name: 'console.appMan.mqttMan',
                    component: resolve => require(['../views/console/appMan/mqttMan'], resolve),
                    meta: { name: '我的MQTT' }
                },
                {
                    path: 'appMan/httpMan',
                    name: 'console.appMan.httpMan',
                    component: resolve => require(['../views/console/appMan/httpMan'], resolve),
                    meta: { name: '我的HTTP' }
                },
                {
                    path: 'appMan/kafkaMan',
                    name: 'console.appMan.httpMan',
                    component: resolve => require(['../views/console/appMan/kafkaMan'], resolve),
                    meta: { name: '我的KAFKA' }
                },
                {
                    path: 'appMan/alarmRule',
                    name: 'console.appMan.alarmRule',
                    component: resolve => require(['../views/console/appMan/alarmRule/index'], resolve),
                    meta: { name: 'KAFKA告警配置' }
                },
                {
                    path: 'appMan/alarmRule/update',
                    name: 'console.appMan.alarmRule',
                    component: resolve => require(['../views/console/appMan/alarmRule/update'], resolve),
                    meta: { name: '积压报警规则' }
                },
                {
                    path: 'appMan/applyList',
                    name: 'console.appMan.applyList',
                    component: resolve => require(['../views/console/appMan/applyList'], resolve),
                    meta: { name: '我的申请记录' }
                },
                {
                    path: 'appMan/applyModuleList',
                    name: 'console.appMan.applyModuleList',
                    component: resolve => require(['../views/console/appMan/applyModuleList'], resolve),
                    meta: { name: '我的申请分类' }
                },
                {
                    path: 'sandbox/api',
                    name: 'console.sandbox.api',
                    component: resolve => require(['../views/console/sandbox/api'], resolve),
                    meta: { name: '沙箱环境' }
                },
                {
                    path: 'quota/index',
                    name: 'console.quota.index',
                    component: resolve => require(['../views/console/quota/index'], resolve),
                    meta: { name: '配额管理' }
                },
                {
                    path: 'quota/detail/index',
                    name: 'console.quota.detail.index',
                    component: resolve => require(['../views/console/quota/detail/index'], resolve),
                    meta: { name: '调用详情' }
                },
                {
                    path: 'sandbox/httpAndMqtt',
                    name: 'console.sandbox.httpAndMqtt',
                    component: resolve => require(['../views/console/sandbox/httpAndMqtt'], resolve),
                },
                {
                    path: 'userCenter',
                    name: 'console.userCenter',
                    component: resolve => require(['../views/console/userCenter'], resolve),
                    meta: { name: '用户中心' }
                },
                {
                    path: 'userCenter/access',
                    name: 'console.userCenter.access',
                    component: resolve => require(['../views/console/userCenter/access'], resolve),
                    meta: { name: 'AccessID管理' }
                },
            ]
        },
        {
            path: '/projectCenter',
            name: 'projectCenter',
            redirect: '/projectCenter/step/1',
            component: resolve => require(['../views/entry'], resolve),
            children: [
                {
                    path: 'step/:stepNumber',
                    name: 'projectCenter.step',
                    component: resolve => require(['../views/projectCenter/index'], resolve),
                    meta: { name: '方案中心' }
                },
                {
                    path: 'result',
                    name: 'projectCenter.result',
                    component: resolve => require(['../views/projectCenter/result'], resolve),
                    meta: { name: '解决方案' }
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: resolve => require(['../views/login'], resolve),
        },
        {
            path: '/forgetPwd',
            name: 'forgetPwd',
            component: resolve => require(['../views/forgetPwd.vue'], resolve),
        },
        // {
        //     path: '/register',
        //     name: 'register',
        //     component: resolve => require(['../views/register.vue'], resolve),
        // },
        {
            path: '/err/:code',
            name: 'err',
            component: resolve => require(['../views/error'], resolve),
        },
        {
            path: '*',
            redirect: '/error/404',
        }
    ],
});

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    if (!needLogin(to.path)) {
        next();
    } else {
        checkLogin().then((isLogin) => {
            if (!isLogin) {
                next(false);
                toIndex();
            }
        });
        next();
    }
});

// 显微镜埋点
router.afterEach((to) => {
    console.log(to);
    // 页面跳转后收起反馈弹窗
    store.commit('updateFeedbackShow', false);
    store.dispatch('getUser').then((res) => {
    	// res.username 登录用户名 根据实际情况调整
        window._paq.push(['setUserId', `${res}`]);
        // 页面名称 根据实际情况调整
        window._paq.push(['setDocumentTitle', to.meta ? to.meta.name : to.name]);
        // 自定义url
        window._paq.push(['setCustomUrl', window.location.origin + window.location.pathname + window.location.hash.replace('#', '@')]);
        // 上报采集数据
        window._paq.push(['trackPageView']);
    });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js